








import { Component,Watch, Vue, Prop } from "vue-property-decorator";
import lax from "lax.js";

@Component
export default class QuoteFloater extends Vue {
    @Prop() quotes: any;

    private initLax() {
        lax.init();

        lax.addDriver("scrollY", function() {
            return window.scrollY;
        });

        lax.addElements(".selector-q", {
            scrollY: {
                opacity: [
                    ["elInY", "elCenterY", "elOutY"],
                    [0, 1, 0]
                ],
                scale: [
                    ["elInY", "elCenterY", "elOutY"],
                    [0.9, 1, 0.9]
                ]
            }
        });
    }
}
